import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { Router } from '../../routes';
import { selectProduct } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer } from "../index";
import { Checkbox } from "../../components";
import { getCategory, slugify } from '../../utils';

const { ParamsOption, CheckboxList } = HotelParamsLine;

const mapStateToProps = state => ({
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductSelection: selectProduct,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class ProductSelector extends Component {
  static propTypes = {
    product: PropTypes.string,
    handleProductSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    market: PropTypes.string,
  };

  getProductTitle = option => {
    const splitOptions = option.split(',');
    let optionsMessage;

    if (splitOptions.length > 1) {
      optionsMessage = `${splitOptions.length} options selected`;
    } else if (splitOptions.length === 1) {
      optionsMessage = splitOptions;
    }

    return optionsMessage;
  };

  handleCheckboxSelect = evt => {
    const { handleProductSelection, product, market } = this.props;
    const { target } = evt;
    let checkboxOptions;

    if (Router.query.product) {
      checkboxOptions = Router.query.product.split(',');
    } else {
      checkboxOptions = product.split(',');
    }

    const containedOptionIndex = checkboxOptions.findIndex(option => option.trim() === target.value);

    if (containedOptionIndex !== -1) {
      checkboxOptions.splice(containedOptionIndex, 1);
    } else {
      checkboxOptions.push(target.value);
    }

    const filteredCheckboxOptions = checkboxOptions.filter(option => option.length !== 0);
    const selectedProduct = filteredCheckboxOptions.join(',');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(selectedProduct),
      product: selectedProduct,
    }, { shallow: true });

    handleProductSelection(selectedProduct);
  };

  render() {
    const { handleCheckboxSelect } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, product } = this.props;

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="product"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'product'}
          isActive={product}
        >
          {product ? this.getProductTitle(product) : 'Select your way'}
        </ParamsOption>
        {currentDropdown === 'product' && (
          <DropdownContainer name="product" handleCloseButtonClick={handleCloseDropdown} onClickOutside={handleCloseDropdown}>
            <CheckboxList onChange={handleCheckboxSelect}>
              <li>
                <Checkbox
                  readonly
                  description="General pool access typically includes fitness center"
                  name="Day Pass"
                  value="Day Pass"
                  checked={product.split(',').includes('Day Pass')}
                  id={0}
                  label="Day Pass"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="Covered sofas include reserved seating for 4-6 guests"
                  name="Cabana"
                  value="Cabana"
                  checked={product.split(',').includes('Cabana')}
                  id={1}
                  label="Cabana"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="General pool access plus spa facilities typically paired with a mini treatment"
                  name="Spa Pass"
                  value="Spa Pass"
                  checked={product.split(',').includes('Spa Pass')}
                  id={2}
                  label="Spa Pass"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="Semi-covered bed for 2-4 guests typically includes water, bottle of bubbly and fruit"
                  name="Daybed"
                  value="Daybed"
                  checked={product.split(',').includes('Daybed')}
                  id={3}
                  label="Daybed"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="Fitness center access and fitness classes"
                  name="Fitness Pass"
                  value="Fitness Pass"
                  checked={product.split(',').includes('Fitness Pass')}
                  id={4}
                  label="Fitness Pass"
                />
              </li>
              <li>
                <Checkbox
                    readonly
                    description=""
                    name="Beach Day Pass"
                    value="Beach Day Pass"
                    checked={product.split(',').includes('Beach Day Pass')}
                    id={7}
                    label="Beach Day Pass"
                />
              </li>
              <li>
                <Checkbox
                    readonly
                    description=""
                    name="Pool and Beach Day Pass"
                    value="Pool and Beach Day Pass"
                    checked={product === 'Pool and Beach Day Pass'}
                    id={8}
                    label="Pool and Beach Day Pass"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="General pool access paired with special events & activities"
                  name="Events"
                  value="Events"
                  checked={product.split(',').includes('Events')}
                  id={5}
                  label="Events"
                />
              </li>
            </CheckboxList>
          </DropdownContainer>
        )}
      </Fragment>
    );
  }
}

export default ProductSelector;
